<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getList, add, del, update, getAccount } from "@/api/user/b2b_feright";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
import { getCustomer, getOwnership } from "@/api/public";

import { getChargingType, getService } from "@/api/double/list";
import { getMethod } from "@/api/system/method";
import { getCategory } from "@/api/storage/category";

import cTable from "@/base/common/index";
import { getExpense } from "@/api/finance/expense";
export default {
  name: "b2b_feright",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: p => {
          return getList(p);
        },
        add,
        del,
        update,
        getAccount,
        getCustomer,
        getOwnership
      },
      selectData: {},
      config: {
        height: 630,
        addData: {}
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["details"] = JSON.parse(JSON.stringify(this.list));
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 60,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "array"
                }
              ],
              is_def: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              service_code: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "array",
                  trigger: "change"
                }
              ],
              transport_code: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { type: 12, client_id: 12 },
            { title: 12, is_def: 12 },
            { from_country: 12, to_country: 12 },
            { service_code: 12, transport_code: 12 },
            { collect_warehouse: 12 },
            { remarks: 24 }
          ],
          fields: [
            {
              key: "type",
              name: () => this.$t("CollectionUser"),
              placeholder() {
                return this.$t("select") + this.$t("CollectionUser");
              },
              component: "Select",
              default: 1,
              clearable: false,
              options: [
                { label: this.$t("Customer"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 }
              ],
              show({ row }) {
                return !row.id;
              },
              methods: {
                "on-change"({ formData, fields, row }) {
                  console.log(formData, row);
                  fields.forEach(field => {
                    if (field.key === "client_id") {
                      if (formData.type == 2 && field.options2) {
                        return (field.options = field.options2);
                      } else if (formData.type == 1 && field.options1) {
                        return (field.options = field.options1);
                      }
                      this.$page
                        .handleRequestMethods(
                          formData.type == 2 ? "getOwnership" : "getCustomer"
                        )
                        .then(res => {
                          field.options = res.payload;
                          if (formData.type == 2)
                            field.options2 = field.options;
                          else field.options1 = field.options;
                        });
                    }
                  });
                }
              }
            },
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              bind: {
                multiple: true
              },
              component: "Select",
              options: [],
              show({ row }) {
                return !row.id;
              },
              methods: {
                list({ field, formData }) {
                  if (formData.type == 2 && field.options2) {
                    return (field.options = field.options2);
                  } else if (field.options1) {
                    return (field.options = field.options1);
                  }
                  this.$page
                    .handleRequestMethods(
                      formData.type == 2 ? "getOwnership" : "getCustomer"
                    )
                    .then(res => {
                      field.options = res.payload;
                      if (formData.type == 2) field.options2 = field.options;
                      else field.options1 = field.options;
                    });
                }
              }
            },
            {
              name: () => this.$t("labelName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("labelName");
              }
            },
            {
              name: () => this.$t("is_def"),
              key: "is_def",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 }
              ],
              default: 2,
              bind: {
                border: true
              }
            },
            {
              name: () => this.$tz("收取仓库费用"),
              key: "collect_warehouse",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 }
              ],
              default: 1,
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("from_country");
              },
              clearable: true,
              options: [],
              config: { label: "code", value: "code" }
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("target_country");
              },
              clearable: true,
              options: [],
              config: { label: "code", value: "code" }
            },
            {
              name: () => this.$t("company"),
              key: "service_code",
              component: "Select",
              bind: {
                multiple: true,
                "max-tag-count": 3
              },
              placeholder() {
                return this.$t("select") + this.$t("company");
              },
              clearable: true,
              options: [],
              config: { label: "service_name", value: "service_code" },
              disabled: ({ row }) => {
                return row.id;
              }
            },
            {
              name: () => this.$t("method_name"),
              key: "transport_code",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("method_name");
              },
              clearable: true,
              options: [],
              config: {
                label({ row }) {
                  return row.method_name + "(" + row.method_code + ")";
                },
                value: "method_code"
              },
              methods: {
                list() {
                  if (this.$modal.params.transport_code) {
                    this.$modal.table.fields.forEach(async t => {
                      if (t.key === "unit_name") {
                        t.options = (
                          await getChargingType({
                            transport: this.$modal.params.transport_code
                          })
                        ).data.payload;
                      }
                    });
                    console.log(
                      "this.$modal.table.fields :>> ",
                      this.$modal.table.fields
                    );
                    this.$forceUpdate();
                  }
                },
                "on-change"({ formData }) {
                  this.$modal.table.fields.forEach(async t => {
                    if (t.key === "unit_name") {
                      t.options = (
                        await getChargingType({
                          transport: formData.transport_code
                        })
                      ).data.payload;
                      console.log(this.$modal.list);
                      this.$modal.list.forEach(t => {
                        t.unit_name = "";
                      });
                    }
                  });
                  console.log(
                    "this.$modal.table.fields :>> ",
                    this.$modal.table.fields
                  );
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              }
            }
          ],
          table: {
            config: {
              height: 300
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning"
                    },
                    icon: "md-add",
                    disabled({ rowIndex }) {
                      return rowIndex != 0;
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled() {
                      return this.list.length == 1;
                    }
                  }
                ],
                methods: {
                  add() {
                    this.getModal("add").list.unshift({
                      cate_id: 0,
                      expense_item: 0,
                      price: 0,
                      unit_name: "",
                      currency: "",
                      min_val: 0,
                      max_val: 0
                    });
                    // let data = JSON.parse(
                    //   JSON.stringify(this.getModal("add").params)
                    // );
                    // this.getModal("add").updateFormData(data);
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("add").list.splice(rowIndex, 1);
                      }
                    });
                  }
                }
              },
              // {
              //   name: () => this.$t("category_name"),
              //   align: "left",
              //   key: "cate_id",
              //   placeholder() {
              //     return this.$t("select") + this.$t("category_name");
              //   },
              //   component: "Select",
              //   bind: {
              //     style: "width:100%",
              //     type: "number"
              //   },
              //   config: {
              //     label: "name",
              //     value: "id"
              //   },
              //   methods: {
              //     async list({ field }) {
              //       field.options = (await getCategory()).data.payload;
              //       this.$forceUpdate();
              //     }
              //   }
              // },
              {
                name: () => this.$t("expense"),
                align: "left",
                key: "expense_item",
                placeholder() {
                  return this.$t("select") + this.$t("expense");
                },
                component: "Select",
                bind: {
                  style: "width:100%",
                  type: "number"
                },
                config: {
                  label({ row }) {
                    return row.name + (row.pin ? "(" + row.pin + ")" : "");
                  },
                  value: "id"
                },
                methods: {
                  async list({ field }) {
                    field.options = (await getExpense()).data.payload.rows;
                    this.$forceUpdate();
                  }
                }
              },
              {
                name: () => this.$t("expType"),
                align: "left",
                key: "unit_name",
                placeholder() {
                  return this.$t("select") + this.$t("expType");
                },
                component: "Select",
                bind: {
                  style: "width:100%"
                },
                options: []
              },
              {
                name: () => this.$t("currencyCode"),
                align: "left",
                key: "currency",
                placeholder() {
                  return this.$t("select") + this.$t("currencyCode");
                },
                component: "Select",
                bind: {
                  style: "width:100%"
                },
                methods: {
                  list({ field }) {
                    field.options = [
                      { label: "CNY", value: "CNY" },
                      { label: "USD", value: "USD" },
                      { label: "SAR", value: "SAR" },
                      { label: "AED", value: "AED" }
                    ];
                    this.$forceUpdate();
                  }
                }
              },
              {
                name: () => this.$t("billing_price"),
                align: "center",
                key: "price",
                placeholder() {
                  return this.$t("enter") + this.$t("billing_price");
                },
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                  step: 0.01
                }
              },
              {
                name: () => this.$t("BillingInterval"),
                children: [
                  {
                    name: () => this.$t("minimum"),
                    align: "center",
                    key: "min_val",
                    placeholder() {
                      return this.$t("enter") + this.$t("minimum");
                    },
                    component: "InputNumber",
                    bind: {
                      style: "width:100%"
                    }
                  },
                  {
                    name: () => this.$t("maximum"),
                    align: "center",
                    key: "max_val",
                    placeholder() {
                      return this.$t("enter") + this.$t("maximum");
                    },
                    component: "InputNumber",
                    bind: {
                      style: "width:100%"
                    }
                  }
                ]
              },
              {
                name: () => this.$t("Remarks"),
                align: "center",
                key: "remarks",
                placeholder() {
                  return this.$t("enter") + this.$t("Remarks");
                },
                component: "Input",
                bind: {
                  style: "width:100%"
                }
              }
            ]
          }
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: []
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" }
          },
          {
            key: "transport_code",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("method_name");
            },
            clearable: true,
            options: [],
            config: {
              label({ row }) {
                return row.method_name + "(" + row.method_code + ")";
              },
              value: "method_code"
            }
          },
          {
            key: "service_code",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("company");
            },
            clearable: true,
            options: [],
            config: { label: "service_name", value: "service_code" }
          },
          {
            key: "is_def",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("is_def");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: 1 },
              { label: this.$t("NO"), value: 2 }
            ]
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 911
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, function() {
                this.list = [
                  {
                    cate_id: 0,
                    expense_item: 0,
                    price: 0,
                    unit_name: "",
                    currency: "",
                    remarks: "",
                    min_val: 0,
                    max_val: 0
                  }
                ];
                this.setTitle(this.$t("add"));
                this.type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("labelName"),
          key: "title",
          align: "left",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("company"),
          key: "service_code",
          minWidth: 80
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 80
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          minWidth: 100
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 100
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_name",
          minWidth: 100,
          methods: {
            render({ value, row }) {
              return value + "(" + row.transport_code + ")";
            }
          }
        },
        {
          name: () => this.$t("is_def"),
          key: "is_def",
          minWidth: 80,
          methods: {
            render({ value }) {
              let options = [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 }
              ];
              return options.find(item => item.value == value).label;
            }
          }
        },
        {
          name: () => this.$tz("是否,收取仓库费用"),
          key: "collect_warehouse_name",
          minWidth: 110
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 100
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("copy"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 910
            },

            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 909
            }
          ],
          methods: {
            copy({ row }) {
              let data = JSON.parse(JSON.stringify(row));
              delete data.id;
              delete data.client_id;
              this.getModal("add").open(data, function() {
                this.list = [
                  {
                    cate_id: 0,
                    expense_item: 0,
                    price: 0,
                    unit_name: "",
                    currency: "",
                    remarks: "",
                    min_val: 0,
                    max_val: 0
                  }
                ];
                if (data.details.length > 0) {
                  data.details.map(item => {
                    delete item.id;
                    return item;
                  });
                  this.list = data.details;
                }
                this.setTitle(this.$t("copy"));
                this.type = "add";
              });
            },
            update({ row }) {
              let data = JSON.parse(JSON.stringify(row));
              this.getModal("add").open(data, function() {
                this.list = [
                  {
                    cate_id: 0,
                    expense_item: 0,
                    price: 0,
                    unit_name: "",
                    currency: "",
                    remarks: "",
                    min_val: 0,
                    max_val: 0
                  }
                ];
                if (data.details.length > 0) this.list = data.details;
                this.setTitle(this.$t("update"));
                this.type = "update";
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  activated() {
    let searchForm = this.$refs["table"].$refs["header"].searchForm;
    searchForm.keywords = this.$store.state.user.pageUrl.label;
    searchForm.client_id = this.$store.state.user.pageUrl.client_id;
    this.$store.state.user.pageUrl = {};
    this.$refs["table"].getList();
  },
  async mounted() {
    this.selectData = {
      from_country: (await getCountry({ allow_depart: 1 })).data.payload.rows,
      to_country: (await getCountry({ allow_arrive: 1 })).data.payload.rows,
      transport_code: (await getMethod()).data.payload.rows,
      service_code: (await getService()).data.payload,
      client_id: (await getAccount()).data.payload
    };
    this.modals.add.fields.forEach(item => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
      if (item.key === "client_id") item.options1 = this.selectData[item.key];
    });
    this.header.searchs.forEach(item => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
  }
};
</script>
